import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';

import { OfferCreateComponent } from './create.component';
import { SINGLE_OFFER_LEAVE_WARNING } from '../single/single-offer.component';

@Injectable({ providedIn: 'root' })
export class OfferCreateDeactivateGuard
  implements CanDeactivate<OfferCreateComponent>
{
  canDeactivate(component: OfferCreateComponent): boolean {
    if (
      component &&
      !component.allowNavigationWithoutConfirm &&
      (component.offerMode === 'create' ||
        component.offerMode === 'createdFromTemplate')
    ) {
      return confirm(SINGLE_OFFER_LEAVE_WARNING);
    }

    return true;
  }
}
